import { AxiosInstance } from 'axios';

export const baseEndpoint = 'cover-letter';

export interface GenerateCoverLetterParams {
  companyName: string;
  jobTitle: string;
  jobDescription: string;
  isCroatian: boolean;
  model?: string;
}

export interface GeneratedCoverLetter {
  rawText: string;
  pdfBase64: string;
  fileName: string;
  pageCount: number;
  fitsOnePage: boolean;
  docUrl: string | null;
  docId: string | null;
  secret: string;
  model: string;
  llmCostUsd: number | null;
}

export class CoverLetterApi {
  constructor(private api: AxiosInstance) {}

  async generate(params: GenerateCoverLetterParams): Promise<GeneratedCoverLetter> {
    // LLM generation + Google Docs rendering (with shorten-and-rerender passes)
    // can run well past the default timeout.
    const response = await this.api.post('/generate', params, { timeout: 300000 });

    return response.data;
  }

  async deleteDoc(docId: string): Promise<void> {
    await this.api.delete(`/doc/${docId}`);
  }
}
